import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { HttpRequestMethods } from '../../constants/utils';
import {
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '../../constants/utils/app.constants';
import {
  FutureActivityRequest,
  FutureActivityResponse
} from '../../models/future-activites/future-activites.interfaces';
import { AuthAccessTokenDetails, OauthAEMConfig } from '../../models/login';
import {
  COMMON_HEADER_KEY,
  CommonConstants,
  commonHeaderInfo
} from '../../models/status-tracker/status-tracker.constants';
import { CustomError } from '../../models/utils';
import { AppTokenService } from '../login';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  logCustomError
} from '../utils';
import { ContentService } from './content.service';

@Injectable({
  providedIn: 'root'
})
export class FutureActivityService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private appToken: AppTokenService,
    private content: ContentService
  ) {}

  getFutureActivities = (
    payload: FutureActivityRequest
  ): Observable<FutureActivityResponse | undefined> => {
    return this.content.getAuthConfigContent().pipe(
      concatMap((authConfig: OauthAEMConfig) => {
        return this.appToken.getAppTokenWithParams(
          authConfig.CLIENT_ID_VALUE,
          authConfig.SCOPE_VALUE_RM
        );
      }),
      concatMap((token: AuthAccessTokenDetails) => {
        const request: FutureActivityRequest = payload;
        commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
        commonHeaderInfo['Authorization'] = token.access_token;

        return new ApiBuilder<
          FutureActivityRequest,
          FutureActivityResponse | CustomError
        >(this.http, this.appConfig)
          .app(IDP_APPS.SKYMILES)
          .endpointKey(
            EndpointKeys['SKYMILES_API_FUTURE_ACTIVITIES_MULTI_REGION']
          )
          .method(HttpRequestMethods['POST'])
          .payload(request)
          .httpHeaders(commonHeaderInfo)
          .timeOut(CommonConstants.TIMEOUT)
          .errorHandler(this.errorHandler)
          .library(Libraries.OVERVIEW)
          .withCredentials(true)
          .create()
          .pipe(
            map((response: FutureActivityResponse | CustomError) => {
              return this.existCustomError(response);
            })
          );
      })
    );
  };

  existCustomError(
    response: FutureActivityResponse | CustomError
  ): FutureActivityResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_FUTURE_ACTIVITIES_MULTI_REGION
      );
      throw throwError(response);
    }
    return response;
  }
}
